import React, { useState } from "react";
import { Button, Input } from "antd";
import { MdOutlineMail, MdOutlineBugReport, MdOutlineLightbulb } from "react-icons/md";
import { adminRequest } from "../Admin/api";

const supportTypes = [
  { value: "SUPPORT", label: "Contact Support", icon: MdOutlineMail },
  { value: "PROBLEM", label: "Report a Problem", icon: MdOutlineBugReport },
  { value: "FEATURE_REQUEST", label: "Feature Request", icon: MdOutlineLightbulb },
];

// Users send a support request; the server records who sent it from the session.
const SupportForm = ({ onDone }) => {
  const [type, setType] = useState("SUPPORT");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !body.trim()) { setError("Please enter a subject and a message."); return; }
    setSending(true); setError("");
    try { await adminRequest("/support", { method: "POST", body: { subject: subject.trim(), message: body.trim(), type } }); setSent(true); setSubject(""); setBody(""); }
    catch (err) { setError(err.message); } finally { setSending(false); }
  };
  if (sent) return (
    <div className="p-5">
      <p className="font-bold text-[17px]">Thanks — your request has been sent.</p>
      <div className="flex gap-2 mt-4"><Button onClick={() => setSent(false)}>Send another</Button>{onDone && <Button onClick={onDone}>Back</Button>}</div>
    </div>
  );
  return (
    <form onSubmit={send} className="p-5 flex flex-col gap-4">
      <p className="font-bold text-[17px]">Support</p>
      <style>{`
        .support-types .ant-btn { height: auto; min-height: 42px; white-space: normal; text-align: left; justify-content: flex-start; box-shadow: none; }
        .support-types .ant-btn[aria-pressed="true"] { color: var(--dashboard-primary, #0099FF); border-color: var(--dashboard-primary, #0099FF); background: var(--dashboard-tint, #EAF6FF); }
      `}</style>
      <div role="group" aria-label="Request type" className="support-types flex flex-wrap gap-2">
        {supportTypes.map(({ value, label, icon: Icon }) => <Button key={value} htmlType="button" icon={<Icon size={18} />} aria-pressed={type === value} disabled={sending} onClick={() => setType(value)}>{label}</Button>)}
      </div>
      <h3 className="font-bold text-[15px]">{supportTypes.find((option) => option.value === type)?.label}</h3>
      <div><label htmlFor="support-subject" className="block font-bold text-[14px] mb-1">Subject</label>
        <Input id="support-subject" maxLength={200} value={subject} onChange={(e) => setSubject(e.target.value)} /></div>
      <div><label htmlFor="support-message" className="block font-bold text-[14px] mb-1">Message</label>
        <Input.TextArea id="support-message" rows={6} maxLength={5000} value={body} onChange={(e) => setBody(e.target.value)} /></div>
      {error && <p className="text-red-600 text-[14px]">{error}</p>}
      <div className="flex gap-2">
        <Button htmlType="submit" type="primary" loading={sending} className="dashboard-primary">Send</Button>
        {onDone && <Button onClick={onDone}>Cancel</Button>}
      </div>
    </form>
  );
};

export default SupportForm;
